import { createSlider } from "../../../../assets/js/slider.js";

function initStorySlider() {
	document.querySelectorAll(".story_slider-layout").forEach((layout) => {
		const el = layout.querySelector(".story-swiper");
		if (!el) return;
		createSlider(layout, ".story-swiper", {
			centeredSlides: true,
			initialSlide: parseInt(el.dataset.initialSlide, 10) || 0,
			slideToClickedSlide: true,
		});
	});
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", initStorySlider);
} else {
	initStorySlider();
}
